<template>
  <div class="home">
    <h3 class="mt-4">Auth Info</h3>
    <hr />

    <b-card title="OIDC User">
      <b-card-text>
        {{ oidcUser }}
      </b-card-text>
    </b-card>

    <b-card title="OIDC Access Token">
      <b-card-text>
        {{ oidcAccessToken }}
      </b-card-text>
    </b-card>

    <b-card title="OIDC Access Token Exp">
      <b-card-text>
        {{ oidcAccessTokenExp }}
      </b-card-text>
    </b-card>

    <b-card title="OIDC Error">
      <b-card-text>
        {{ oidcError }}
      </b-card-text>
    </b-card>
  </div>
</template>

<script lang="ts">
import { User } from "oidc-client";
import { defineComponent } from "vue";

export default defineComponent({
  name: "AuthInfo",
  computed: {
    oidcUser(): User {
      return (this as any).$store.getters.oidcUser;
    },

    oidcAccessToken(): string {
      return (this as any).$store.getters.oidcAccessToken;
    },

    oidcAccessTokenExp(): number {
      return (this as any).$store.getters.oidcAccessTokenExp;
    },

    oidcError(): string {
      return (this as any).$store.getters.oidcError;
    }
  }
});
</script>
